import { QueryClient } from "@tanstack/react-query";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (failureCount, error) => {
        // Don't retry on 401 authentication errors
        if (error?.response?.status === 401) {
          return false;
        }
        // Don't retry on 4xx client errors (except network issues)
        if (error?.response?.status >= 400 && error?.response?.status < 500) {
          return false;
        }
        // Retry up to 2 times for other errors
        return failureCount < 2;
      },
      retryDelay: attemptIndex => Math.min(1000 * 2 ** attemptIndex, 10000),
    },
    mutations: {
      retry: (failureCount, error) => {
        // Don't retry mutations on 401 errors
        if (error?.response?.status === 401) {
          return false;
        }
        // Don't retry on 4xx client errors
        if (error?.response?.status >= 400 && error?.response?.status < 500) {
          return false;
        }
        // Retry mutations once for server/network errors
        return failureCount < 1;
      },
    },
  },
});

export default queryClient;
